import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as req from 'src/app/entities/request';
import * as res from 'src/app/entities/response';
import { environment } from 'src/environments/environment';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ActiveInactiveFor, GeneralConfigType, InteractionType, KeyValues3, KeyValueSet, LocalService, PageKey, PrinterTab, Status } from 'src/service/local.service';
import { OfflineService } from 'src/service/offline.service';
import { PrinterService } from 'src/service/printer.service';

@Component({
  selector: 'app-local-printer',
  templateUrl: './local-printer.component.html',
  styleUrl: './local-printer.component.scss'
})
export class LocalPrinterComponent {
  PrinterTab = PrinterTab;
  lstSectionConfigKeys: string[] = ["common", "table", "printer", "seller"];
  ctryCode: string = ''; businessId: string = ''; interactionType = 0; maxBodyHeight = 0;
  @Input() tabs: KeyValueSet[]; selectedTab: string = PrinterTab.DeviceMapping.toString();
  isOfflineServiceAvailable: boolean | null = null; deviceId: string = '';
  temporaryFolder: string = ''; printerSetup: res.PrinterSetup; isOtpVerified: boolean = false;
  additionalData: KeyValues3 = { v1: 'Printer Setup' } as KeyValues3;

  constructor(public localService: LocalService, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private offlineService: OfflineService, private printerService: PrinterService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.isOtpVerified = this.interactionType == InteractionType.Bill_PnixSoft;
      this.configurationManagementService.ensurePageActions(PageKey.LocalPrinter, this.businessId);
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onCheckServiceAvailability();
    if (this.isOtpVerified) {
      const iConfigTypes = [GeneralConfigType.PrinterTab];
      this.configurationManagementService.getConfigurationsToDisplayMulti(iConfigTypes, true, false).subscribe(result => {
        result.forEach(item => {
          switch (parseInt(item.key)) {
            case GeneralConfigType.PrinterTab: {
              this.tabs = this.localService.Sort(item.value, false, "value");
            } break;
          }
        });
      });
    }
    this.onLoad();
  }

  onReset() {
    if (this.printerSetup) {
      if (!this.printerSetup.TemporaryFolder) {
        this.printerSetup.TemporaryFolder = this.temporaryFolder;
      }
      if (!this.printerSetup.ServiceUrl) {
        this.printerSetup.ServiceUrl = environment.url.offlline_service;
      }
    } else {
      this.printerSetup = {
        IsOn: true,
        IsOfflineApplication: !environment.url.app_without_www.includes('lazy'),
        TemporaryFolder: this.temporaryFolder,
        ServiceUrl: environment.url.offlline_service
      } as res.PrinterSetup;
    }
  }

  onLoad() {
    if (this.isOtpVerified) {
      this.onIsPrinterTabAvailable();
    }
  }

  onIsPrinterTabAvailable(isShowSpinner = true) {
    const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode() } as req.BusinessDetail;
    this.printerService.isPrinterTabAvailable(req, isShowSpinner).subscribe(result => {
      if (result && this.tabs) {
        this.tabs.forEach(tab => {
          const item = result.find(x => x.PrinterTab == parseInt(tab.key));
          tab.isSelected = !(item && item.Status == Status.Success);
        });
      }
    });
  }

  onLanguageChanged() {
    this.onInitiate();
  }

  onCheckServiceAvailability() {
    if (this.isOtpVerified) {
      this.offlineService.isServiceAvailable(this.businessId).subscribe(result => {
        this.isOfflineServiceAvailable = result.status == Status.Success;
        this.localService.isOfflineServiceAvailable = this.isOfflineServiceAvailable;
        this.onGetTemporaryFolder();
      }, error => {
        this.isOfflineServiceAvailable = false;
        this.localService.isOfflineServiceAvailable = this.isOfflineServiceAvailable;
        this.onLoadPrinterSetup();
      });
    }
  }

  onGetTemporaryFolder() {
    if (this.isOfflineServiceAvailable) {
      this.offlineService.getTemporaryFolder(this.businessId).subscribe(result => {
        if (result.status == Status.Success) {
          this.localService.offlineServiceTempFolder = result.id;
          this.temporaryFolder = result.id;
        }
        this.onLoadPrinterSetup();
      });
    } else {
      this.onLoadPrinterSetup();
    }
  }

  onLoadPrinterSetup() {
    const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode() } as req.BusinessDetail;
    this.printerService.getPrinterSetupByBusinessId(req).subscribe(result => {
      if (result && result.Mandatory.Status == Status.Success) {
        this.printerSetup = result;
        this.onReset();
      } else {
        this.onReset();
      }
    });
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onCheckServiceAvailability();
      } break;
      case 2: {
        this.selectedTab = PrinterTab.TemplateMapping.toString();
      } break;
      case 3: {
        this.selectedTab = PrinterTab.AvailablePrinters.toString();
      } break;
      case 4: {
        this.selectedTab = PrinterTab.Devices.toString();
      } break;
      case 5: {
        this.localService.copyContent(this.deviceId);
      } break;
      case 6: {
        this.selectedTab = PrinterTab.Templates.toString();
      } break;
      case 7: {
        this.onLoad();
      } break;
    }
  }

  onActiveInactiveStatus(key?: string) {
    if (key) {
      const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode() } as req.BusinessDetail;
      this.printerService.activeInactiveStatus(req, key, ActiveInactiveFor.PrinterSetupOnOff).subscribe(result => {
        if (result && result.status) {
          if (result.status == Status.Success) {
            this.printerSetup.IsOn = !this.printerSetup.IsOn;
            if (this.localService.userDevicePrinterSetupWrapper.devicePrinterSetups.length > 0) {
              this.localService.userDevicePrinterSetupWrapper.devicePrinterSetups.filter(x => x.BusinessId == this.businessId).forEach(item => {
                item.IsOn = this.printerSetup.IsOn;
              });
            }
            this.localService.showMessage(this.localService.languageContent.printer.request_relogin);
          }
          this.localService.showInformationByStatus(result.status);
        }
      });
    }
  }

  onSave() {
    const req = {
      BusinessId: this.businessId,
      CountryCode: this.localService.getLoginAsCountryCode(),
      Key: this.printerSetup.Key,
      IsOfflineApplication: this.printerSetup.IsOfflineApplication,
      ServiceUrl: this.printerSetup.ServiceUrl,
      TemporaryFolder: this.printerSetup.TemporaryFolder,
      IsOn: this.printerSetup.IsOn
    } as req.PrinterSetup;
    this.printerService.savePrinterSetup(req).subscribe(result => {
      if (result && result.status == Status.Success) {
        this.onLoadPrinterSetup();
      }
      this.localService.showInformationByStatus(result.status);
    });

  }

  ngOnDestroy(): void {
    let element = document.getElementById('on_printer_setup_changed') as HTMLElement;
    if (element)
      element.click();
  }

  onVerifiedOtp(e: any) {
    this.isOtpVerified = true;
    this.onCheckServiceAvailability();
    this.onInitiate();
  }
}
